import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-add",
  "use": "svg_i-add-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"svg_i-add\"><rect x=\"4\" width=\"2\" height=\"10\" rx=\"1\" fill=\"currentColor\" /><path d=\"M9 4a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h8Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol